import * as FiIcons from 'react-icons/fi';

/** Every Feather icon exported by react-icons, for the picker to search. */
export const FI_ICON_NAMES = Object.keys(FiIcons).filter((key) => key.startsWith('Fi'));

/**
 * Renders a Feather icon chosen in the admin by name.
 *
 * Unknown or empty names render nothing rather than throwing: the name comes
 * from stored settings, and a rename in react-icons should cost a missing icon
 * at worst, never a blank page.
 */
export default function FiIcon({ name, className = 'w-4 h-4' }) {
  const Icon = name ? FiIcons[name] : null;
  if (!Icon) return null;
  return <Icon className={className} aria-hidden="true" />;
}
